import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { AlertService, RxjsService } from '@app/shared/services';
import { Role } from '@user/models';
import { RoleService } from '@user/services';

@Component({
  selector: 'role-add-edit',
  templateUrl: './role-add.component.html',
  styleUrls: ['./role-add.component.scss']
})

export class RoleAddEditComponent implements OnInit {
  @Input() id: string;
  roleAddEditForm: FormGroup;
  role = new Role();
  btnName: string;
  isDialogLoaderLoading: boolean;
  RoleCategoryList: any;
  public alphaNumericWithSpacePattern = { '0': { pattern: new RegExp('^[A-Za-z0-9 ]*$') } };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Role,
    private dialog: MatDialog,
    private roleServies: RoleService,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private rxjsService: RxjsService) {
  }
  //Initialize the components...
  ngOnInit(): void {
    this.rxjsService.setDialogOpenProperty(true);
    if (this.data.roleId) {
      this.btnName = 'Update';
    } else {
      this.btnName = 'Create';
    }

    this.roleAddEditForm = this.formBuilder.group({
      roleName: this.data.roleName || '',
      roleCategoryId: this.data.roleCategoryId || '',
      shortCode: this.data.shortCode || '',
      htmlBadge: this.data.htmlBadge || '',
      description: this.data.description || '',
    });

    this.roleServies.getRoleCategories().subscribe({
      next: response => {
        this.RoleCategoryList = response.resources;
      }
    });
  }

  //Save role values...
  save(): void {
    if (this.roleAddEditForm.invalid) {
      this.roleAddEditForm.markAllAsTouched();
      return;
    }
    const role = { ...this.data, ...this.roleAddEditForm.value }
    if (role.roleId != null) {
      this.roleServies.updateRole(role).subscribe({
        next: response => this.onSaveComplete(response)
      });
    }
    else {
      this.roleServies.createRole(role).subscribe({
        next: response => this.onSaveComplete(response)
      });
    }
  }
  //After completing save...
  onSaveComplete(response): void {
    if (response.statusCode == 200) {
      this.dialog.closeAll();
      this.roleAddEditForm.reset();
    }
    else {
      this.alertService.processAlert(response);
    }
  }
}
